import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "dispatcher-couriers" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "text-sm mt-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, "Для получения отчетов укажите сектор диспетчера", -1)
const _hoisted_5 = { class: "flex items-center justify-end mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_7 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_report_list_item = _resolveComponent("report-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.complete_state.is_modal_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large",
          title: "Ошибки при завершении дня",
          "without-footer": "",
          onCancel: _ctx.resetCompleteState
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, "Курьер: " + _toDisplayString(_ctx.complete_state.complete_item.fullName), 1),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.complete_state.errors, (error) => {
                return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.loadReports(1)), ["prevent"])),
      class: "bg-white border px-6 py-4"
    }, [
      _hoisted_4,
      _createVNode(_component_the_select, {
        class: "mt-3",
        value: _ctx.filters_state.dispatchers_sector_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.dispatchers_sector_id) = $event)),
        placeholder: "Выберите сектор диспетчера",
        loading: _ctx.data_state.dispatchers_sectors.is_loading,
        options: _ctx.data_state.dispatchers_sectors.list,
        failed: _ctx.data_state.dispatchers_sectors.is_failed,
        "error-text": "При получении списка секторов диспетчера произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        onRefresh: _ctx.loadDispatchersSectors
      }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_button, {
          class: "second small text mr-3",
          loading: _ctx.state.is_loading,
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary small",
          loading: _ctx.state.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createVNode(_component_page_title, {
      class: "mt-6",
      title: "Отчет по курьерам"
    }),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка отчетов произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadReports(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_list, {
            key: 1,
            loading: _ctx.state.is_loading,
            items: _ctx.state.list
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_report_list_item, {
                item: item,
                "complete-disabled": _ctx.complete_state.is_loading,
                "complete-loading": 
                            _ctx.complete_state.is_loading &&
                            _ctx.complete_state.complete_item &&
                            _ctx.complete_state.complete_item.courierId === item.courierId
                        ,
                onCompleteDay: _ctx.completeCourierDay
              }, null, 8, ["item", "complete-disabled", "complete-loading", "onCompleteDay"])
            ]),
            _: 1
          }, 8, ["loading", "items"]))
    ])
  ]))
}